import { border_positive_muted } from "@clockwise/design-system/tokens";
import React from "react";

export const EmphasisBadge = () => {
  return (
    <div
      style={{ backgroundColor: border_positive_muted }}
      className={
        "cw-rounded-full cw-w-1 cw-h-1 cw-absolute -cw-top-[8px] cw-left-2 cw-z-[1000] cw-animate-emphasis-badge-pulse"
      }
    />
  );
};
